import { ThemeOptions } from '@mui/material';
import { colors } from '@sensei/pi-component';

export const MuiLink = (theme: ThemeOptions) => {
    return {
        styleOverrides: {
            ...theme.components?.MuiLink?.styleOverrides,
            root: {
                color: colors.CARBON,
            },
            /** Styles applied to the root element if underline="none". */
            underlineNone: {
                color: colors.CARBON,
            },
            /** Styles applied to the root element if `underline="hover"`. */
            underlineHover: {
                color: colors.CARBON,
            },
            /** Styles applied to the root element if `underline="always"`. */
            underlineAlways: {
                color: colors.CARBON,
            },
        },
    };
};
